export default {
    namespaced: true,
    state() {
        return {
            locales: [],
        }
    },
    actions: {
        loadLocales({commit}) {
            api.locale.index().then(
                response => commit('setLocales', response.data.data)
            )
        },
    },
    mutations: {
        setLocales(state, locales) {
            state.locales = locales;
        },
    },
}
